import Storage from './Storage';

export const PROVIDER_SESSION_STORAGE_KEY = 'adapt-mh.provider.session';
export const DEMO_PROVIDER_PIN = '2468';
export const PROVIDER_SESSION_TTL_MS = 30 * 60 * 1000;

export type ProviderSession = {
  authenticatedAt: string;
  expiresAt: string;
};

export const createProviderSession = (): ProviderSession => {
  const now = Date.now();

  return {
    authenticatedAt: new Date(now).toISOString(),
    expiresAt: new Date(now + PROVIDER_SESSION_TTL_MS).toISOString(),
  };
};

export const saveProviderSession = async (): Promise<ProviderSession> => {
  const session = createProviderSession();
  await Storage.set(PROVIDER_SESSION_STORAGE_KEY, JSON.stringify(session));
  return session;
};

export const clearProviderSession = async (): Promise<boolean> => {
  return Storage.remove(PROVIDER_SESSION_STORAGE_KEY);
};

export const loadProviderSession = async (): Promise<ProviderSession | null> => {
  const rawValue = await Storage.get(PROVIDER_SESSION_STORAGE_KEY);
  if (!rawValue) return null;

  try {
    const session = JSON.parse(rawValue) as ProviderSession;
    if (!session.expiresAt || Date.parse(session.expiresAt) <= Date.now()) {
      await clearProviderSession();
      return null;
    }

    return session;
  } catch {
    await clearProviderSession();
    return null;
  }
};
